"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
var ComingSoon = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: ", ";\n\theight: ", ";\n\tfont-size: 0.8125rem;\n\tline-height: 1rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 2px;\n\tbackground: linear-gradient(134deg, rgba(107, 159, 247, 1) 0%, rgba(17, 102, 247, 1) 100%);\n\tcolor: #fff;\n\tfont-family: \"SFProText-Regular\";\n\tfont-weight: 400;\n"], ["\n\twidth: ", ";\n\theight: ", ";\n\tfont-size: 0.8125rem;\n\tline-height: 1rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 2px;\n\tbackground: linear-gradient(134deg, rgba(107, 159, 247, 1) 0%, rgba(17, 102, 247, 1) 100%);\n\tcolor: #fff;\n\tfont-family: \"SFProText-Regular\";\n\tfont-weight: 400;\n"])), function (props) { return props.bWidth; }, function (props) { return props.bHeight; });
var RemindMeBtn = (function (_super) {
    __extends(RemindMeBtn, _super);
    function RemindMeBtn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.remindMe = function (e) {
            var remindRightBtn = _this.props.remindRightBtn;
            remindRightBtn();
            e.stopPropagation();
        };
        return _this;
    }
    RemindMeBtn.prototype.render = function () {
        var _a = this.props, bWidth = _a.bWidth, bHeight = _a.bHeight;
        return (React.createElement(ComingSoon, { bWidth: bWidth, bHeight: bHeight }, "Coming Soon"));
    };
    return RemindMeBtn;
}(React.Component));
exports.default = RemindMeBtn;
var templateObject_1;
